import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import ArticleDiffModal from '@/components/container/modal/article/ArticleDiffModal'

interface ArticleDiffModalState {
  siteId: number
  articleProposalId: number
  articleId?: number
}

const defaultValue: ArticleDiffModalState = { siteId: 0, articleProposalId: 0 }

export const ArticleDiffModalContext = createModalContext<ArticleDiffModalState>(defaultValue)

const ArticleDiffModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<ArticleDiffModalState>(defaultValue)
  return (
    <ArticleDiffModalContext.Provider value={state}>
      {children}
      <ArticleDiffModal />
    </ArticleDiffModalContext.Provider>
  )
}

export default ArticleDiffModalProvider
